import { useState } from "react";
import { toast } from "sonner";
import { createLead, uploadPhotos } from "@/services/leadsService";
import { API } from "@/services/apiClient";

// `website` is an invisible honeypot — only bots fill it.
const EMPTY = { name: "", phone: "", email: "", service: "", message: "", website: "" };

// Encapsulates quote-form state, validation, photo upload and submission.
export const useLeadForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const setField = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please enter your name and phone number.");
      return;
    }
    setLoading(true);
    try {
      let photos = [];
      if (files.length) {
        if (files.length > 5) toast.info("Maximum 5 photos — sending the first 5.");
        const uploaded = await uploadPhotos(files.slice(0, 5));
        photos = uploaded.map((u) => `${API}/files/${u.path}`);
      }
      await createLead({ ...form, photos });
      toast.success("Request sent! We'll reach out shortly.");
      setForm(EMPTY);
      setFiles([]);
      setSubmitted(true);
    } catch (err) {
      toast.error("Something went wrong. Please call us directly.");
    } finally {
      setLoading(false);
    }
  };

  const reset = () => setSubmitted(false);

  return { form, setField, files, setFiles, loading, submitted, submit, reset };
};
